export default __webpack_public_path__ + "static/media/microsoft.41dfc5ce.svg";